import React from 'react';
import './AboutPage.scss';
import Reveal from '../Reveal/Reveal';
// Import hero photograph — moved here from the gallery, replacing the
// regional-convention photo already used on the homepage.
import homeimg from '../../images/BackgroundImages/everyone.JPEG';
// Portrait/landscape pair for the graduation plate group
import stolesimg from '../../images/BackgroundImages/stoles.JPEG';
import graduatesimg from '../../images/BackgroundImages/graduates.JPEG';
// Import sub-components for the about page sections
import AboutStatistics from '../AboutStatistics/AboutStatistics';
import AboutChapterTimeline from '../AboutChapterTimeline/AboutChapterTimeline';
import AboutNationalHistory from '../AboutNationalHistory/AboutNationalHistory';

// Main About page component that combines all about-related sections.
// Composed as: a title on paper, a clean chapter photograph plate, then
// statistics, chapter timeline, and national history sections, each
// separated by a hairline rule or paper-sunk band.
function AboutPage() {

    return (
    <div className="about-page">
        <header className="about-hero">
          <Reveal as="h1" variant="mask" className="about-hero-title">About Us</Reveal>
        </header>
        {/* Chapter photograph as a clean, generous plate — no scrim, no text overlay */}
        <Reveal as="div" variant="plate" className="about-hero-plate">
          <img src={homeimg} alt="" className="about-hero-photo" />
        </Reveal>
        {/* Statistics section showing chapter metrics */}
        <AboutStatistics />
        {/* Timeline section showing chapter history */}
        <AboutChapterTimeline />
        {/* Graduation photograph pair — portrait detail beside a landscape group shot */}
        <div className="about-grad-pair">
          <Reveal as="div" variant="plate" index={0} className="about-grad-pair-frame about-grad-pair-frame--portrait">
            <img src={stolesimg} alt="" loading="lazy" />
          </Reveal>
          <Reveal as="div" variant="plate" index={1} className="about-grad-pair-frame about-grad-pair-frame--landscape">
            <img src={graduatesimg} alt="" loading="lazy" />
          </Reveal>
        </div>
        {/* National history section showing Theta Tau's founding story */}
        <AboutNationalHistory />
    </div>
    );
}

export default AboutPage;
